package com.eladfinish.bible.contest.screens.browse.contentOfChapter.model

import com.eladfinish.bible.contest.data.common.DocumentTextType

data class OutputConfig(
    val text: String,
    val shouldAddParenthesisOnOtiotPasuk: Boolean,
    val shouldIncludeOnlyBookNameInFileName: Boolean = false,
    val documentTextType: DocumentTextType = DocumentTextType.TXT,
)
